import React, { useState, useEffect } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { Modal } from 'rsuite';
import 'rsuite/SelectPicker/styles/index.css';
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";

function RecentlyChangedSymbols() {


      const [tabName, setTabName] = useState('Company Name Update');
        useEffect(() => {
          document.title = tabName;
        }, [tabName]);

    const toast = useToast();
    const toastIdRef = React.useRef();

    const apiEndPoint = process.env.REACT_APP_SYMBOL_API_ENDPOINT;

    const [companySymbolData, setCompanySymbolData] = useState("");
    const [companyNameData, setCompanyNameData] = useState("");
    const [ticker, setTicker] = useState("");
    const [count, setCount] = useState("");
    const [inputValue, setInputValue] = useState('');
    const [selectedCompanyName, setSelectedCompanyName] = useState('');


    const [symbolData, setSymbolData] = useState([]);

     useEffect(() => {
    fetch(`${apiEndPoint}`)
      .then((response) => response.json())
      .then((resData) => {
        if (resData?.data?.status === "success" && Array.isArray(resData.data.data)) {
          setSymbolData(resData.data.data);
        } else {
          toastIdRef.current = toast({ description: "Invalid data format received", status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
        }
      })
      .catch((err) => {
        console.error("Error fetching symbol change data:", err);
        toastIdRef.current = toast({ description: "Failed to fetch data", status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
      });
  }, []);

    const handleSearch = () => {
        setActiveRows([]);
        setActiveRows1([]);
        setTicker(inputValue.trim());
    };


    useEffect(() => {
        if (!ticker) return;

        const fetchCompanyInfo = async () => {
            try {
                const response = await fetch(`${apiEndPoint}/company_info/${ticker}`);
                const result = await response.json();

                if (result?.data?.status === 'success') {
                    setCompanySymbolData(result.data.data.company_symbol);
                    setCompanyNameData(result.data.data.company_name);
                    setTicker(result.data.data.main_ticker[0]);
                    setCount(result.data.count);
                } else {
                    setCompanySymbolData([]);
                    setCompanyNameData([]);
                    setCount(result.data.count);
                    toastIdRef.current = toast({ description: result?.data?.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
                }
            } catch (err) {
                toastIdRef.current = toast({ description: "An error occurred while fetching data", status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
                console.error(err);
            }
        };

        fetchCompanyInfo();
    }, [ticker]);



    const [activeRows, setActiveRows] = useState([]);
    const [isUpdateSymbolModalOpen, setIsUpdateSymbolModalOpen] = useState(false);

    const [isDataTableModalOpen, setIsDataTableModalOpen] = useState(false);

    const handleRowClick = (id) => {
        setActiveRows(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const selectedSymbols = Array.isArray(companySymbolData)
        ? companySymbolData
            .filter((item, index) => activeRows.includes(index))
            .map(item => item.company_symbol)
        : [];

    const unselectedSymbols = Array.isArray(companySymbolData)
        ? companySymbolData
            .filter((_, index) => !activeRows.includes(index))
            .map(item => item.company_symbol)
        : [];




    const [activeRows1, setActiveRows1] = useState([]);


    const handleRowClick1 = (id) => {
        if (activeRows1.length === 0 || activeRows1.includes(id)) {
            if (activeRows1.includes(id)) {
                setActiveRows1([]);
                setSelectedCompanyName('');
            } else {
                setActiveRows1([id]);
                setSelectedCompanyName(companyNameData[id]?.name || '');
            }
        } else {
            toastIdRef.current = toast({ description: "You can select only one company at a time", status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
        }
    };





    const handleOpen = () => {
        let hasError = false;

        if (activeRows.length === 0) {
            toastIdRef.current = toast({
                description: "Please select at least one company Symbol from the Left Section.",
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'bottom-left',
            });
            hasError = true;
        }

        if (activeRows1.length === 0) {
            toastIdRef.current = toast({
                description: "Please select Only one company Name from the Right Section",
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'bottom-left',
            });
            hasError = true;
        }



        if (hasError) return;


        setIsUpdateSymbolModalOpen(true);
        setIsDataTableModalOpen(true);

    };

    const handleUpdateSymbolModalClose = () => setIsUpdateSymbolModalOpen(false);
    const handleDataTableModalClose = () => setIsDataTableModalOpen(false);



    const handleSubmit = async () => {
        try {
            const response = await fetch(`${apiEndPoint}/remove_companys`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_name: selectedCompanyName,
                    main_ticker: ticker,
                    sub_tickers: selectedSymbols,
                }),
            });

            const result = await response.json();
            console.log('API Response:', result);
            if (result.data.status === 'success') {
                toastIdRef.current = toast({ description: result.data.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom-left', });
                setIsUpdateSymbolModalOpen(false);

            } else {
                toastIdRef.current = toast({ description: "Something went wrong", status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
            }

        } catch (error) {
            console.error('Error calling API:', error);
            toastIdRef.current = toast({ description: "API call failed", status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
        }
    };

    const handleOpenModal = () => {
        setIsDataTableModalOpen(true);
    };

    const symbolTableData = [
        {
            ticker: "KWS.L",
            old_name: "Keywords Studios Ltd",
            old_created_date: "2025-05-30",
            new_name: "Keywords Studios PLC",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "MTW.L",
            old_name: "Mattioli Woods Ltd",
            old_created_date: "2025-05-30",
            new_name: "Mattioli Woods PLC",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "NETW.L",
            old_name: "Network International Holdings Ltd",
            old_created_date: "2025-05-30",
            new_name: "Network International Holdings PLC",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "PHC.L",
            old_name: "Plant Health Care Ltd",
            old_created_date: "2025-05-30",
            new_name: "Plant Health Care PLC",
            new_created_date: "2024-08-13"
        },
        {
            ticker: "RDW.L",
            old_name: "Redrow Ltd",
            old_created_date: "2025-05-30",
            new_name: "Redrow PLC",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "SND.L",
            old_name: "Sondrel (Holdings) Ltd",
            old_created_date: "2025-05-30",
            new_name: "Sondrel (Holdings) PLC",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "SPWR",
            old_name: "Complete Solaria Inc",
            old_created_date: "2025-05-30",
            new_name: "SunPower Corporation",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "SPYL.NS",
            old_name: "Shekhawati Poly-Yarn Ltd",
            old_created_date: "2024-08-14",
            new_name: "Shekhawati Industries Ltd",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "STCN",
            old_name: "Steel Connect LLC",
            old_created_date: "2025-05-30",
            new_name: "Steel Connect Inc",
            new_created_date: "2025-02-21"
        },
        {
            ticker: "UGE.V",
            old_name: "UGE International Ltd (Pre-Merger)",
            old_created_date: "2025-05-30",
            new_name: "UGE International Ltd",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "ULTI.OL",
            old_name: "Ultimovacs ASA",
            old_created_date: "2025-02-21",
            new_name: "Zelluna ASA",
            new_created_date: "2025-03-25"
        },
        {
            ticker: "VOLUE.OL",
            old_name: "Volue AS",
            old_created_date: "2025-05-30",
            new_name: "Volue ASA",
            new_created_date: "2024-08-14"
        },
        {
            ticker: "ZZZ.TO",
            old_name: "Sleep Country Canada Holdings Inc (Pre-Merger)",
            old_created_date: "2025-05-30",
            new_name: "Sleep Country Canada Holdings Inc",
            new_created_date: "2024-08-14"
        }
    ];


    return (
        <>
            <Sidebar />
            <ChakraProvider resetCSS={false}></ChakraProvider>
            <div id='header'>
                <div className='logo'>
                    <div className='logo_icon'>
                        <img src={Logo} alt="Logo" />
                    </div>
                    <div className='brand_name'>Company Name Update</div>
                </div>
            </div>

            <div className="container-fluid content mt-3 pb-5">
                <div className='search__with__result'>
                    <div className='symbol_search_box'>
                        {/* <input type='text' placeholder='Enter Symbol' value={inputValue}  onChange={(e) => setInputValue(e.target.value)} */}
                        <input type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { handleSearch(); } }} placeholder="Enter ticker" />

                        <button className='btn__send' onClick={handleSearch}>Search</button>
                    </div>

                    <button className='btn__save1' onClick={handleOpenModal}>Changed Companies</button>

                    {/* <ul className='search__result'>
                        <li>Symbol: <span>AAPL</span></li>
                        <li>Total Count: <span>20</span></li>
                    </ul> */}
                    <div className='search__result_row'>
                        <div class="input__group_redis">
                            <div class="input__group_redis_label_button">
                                <div class="form_check__2">
                                    <label class="form-check-label">Main Ticker</label>
                                </div>
                            </div>
                            <div class="input__group_redis_value">{ticker}</div>
                        </div>

                        <div class="input__group_redis">
                            <div class="input__group_redis_label_button">
                                <div class="form_check__2">
                                    <label class="form-check-label">Total Count</label>
                                </div>
                            </div>
                            <div class="input__group_redis_value">{count}</div>
                        </div>
                    </div>
                </div>

                <div className='table__search__row pt-4'>
                    <div className='company_table_list'>
                        <div className='table-responsive' style={{ paddingBottom: 0 }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th width='30' style={{ textAlign: 'center' }}></th>
                                        <th>Name</th>
                                        <th style={{ textAlign: 'center' }}>Symbol</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {companySymbolData.length > 0 ? (companySymbolData.map((item, id) => (
                                        <tr >
                                            <td style={{ textAlign: 'center' }}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`checkbox_${id}`}
                                                        onChange={() => handleRowClick(id)}
                                                        checked={activeRows.includes(id)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`checkbox_${id}`}
                                                    >&nbsp;</label>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className="company_name_td" style={{ justifyContent: 'center' }}>
                                                    <span className="stock_lable">{item.company_symbol}</span>
                                                </div>
                                            </td>
                                            <td>{item.created_date}</td>
                                        </tr>
                                    ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: "center", fontSize: 20, paddingTop: 30, paddingBottom: 30 }}>
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className='company_table_list'>
                        <div className='table-responsive' style={{ paddingBottom: 0 }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th width='30' style={{ textAlign: 'center' }}></th>
                                        <th>Company Name</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {companyNameData.length > 0 ? (companyNameData.map((item, id) => (
                                        <tr key={item.id}>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`checkbox_c_${id}`}
                                                        onChange={() => handleRowClick1(id)}
                                                        checked={activeRows1.includes(id)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`checkbox_c_${id}`}
                                                    >&nbsp;</label>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item.created_date}</td>
                                        </tr>
                                    ))
                                    ) : (
                                        <tr>
                                            <td colSpan="14" style={{ textAlign: "center", fontSize: 20, paddingTop: 30, paddingBottom: 30 }}>
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='text-center mt-5'>
                    <button className='btn__save' onClick={handleOpen}>Save</button>
                </div>
            </div>

            <Modal open={isUpdateSymbolModalOpen} onClose={handleUpdateSymbolModalClose} className="edit_status_modal">
                <Modal.Header className="edit_modal_header">
                    <Modal.Title className="edit_modal_title">Update Company Profile</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="update_symbol_modal_content">
                        <div className='mb-4'>
                            <h5>Selcted New Company Name:</h5>
                            <div className='selected__symbol__name'>{selectedCompanyName}</div>
                        </div>
                        <h6>Selected Companies</h6>
                        <p>These companies and their symbols will be saved to your account:</p>
                        <ul className='update_symbol__list mt-3'>
                            {selectedSymbols.map((symbol, index) => (
                                <li key={index}>
                                    <span className='tag_td halal_tag'>{symbol}</span>
                                </li>
                            ))}
                        </ul>
                        <div className='symbol__remove'>
                            <h6>Symbols to Be Removed</h6>
                            <p>These symbols will be removed from our system:</p>
                            <ul className='update_symbol__list mt-3'>
                                {unselectedSymbols.map((symbol, index) => (
                                    <li key={index}>
                                        <span className='tag_td not_halal_tag'>{symbol}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="modal_footer_edit_status">
                    <div className="btn__group">
                        <button type="button" className="btn_cancel" onClick={handleUpdateSymbolModalClose}>Cancel</button>
                        <button className="btn__save" onClick={handleSubmit}>Submit</button>
                    </div>
                </Modal.Footer>
            </Modal>


            <Modal open={isDataTableModalOpen} onClose={handleDataTableModalClose} className="symbol_change_data_table_modal">
                <Modal.Header className="edit_modal_header">
                    <Modal.Title className="edit_modal_title">Recent Company Name Changes</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="update_symbol_modal_content">
                        <div className="company_table_list">
                            <div className="table-responsive" style={{ paddingBottom: 0 }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>Ticker</th>
                                            <th>Old Name</th>
                                            <th style={{ textAlign: 'center' }}>Old Created Date</th>
                                            <th>New Name</th>
                                            <th style={{ textAlign: 'center' }}>New Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {symbolData?.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ textAlign: 'center' }}>
                                                    <span className="company_lable" style={{ margin: 'auto' }}>
                                                        {item.ticker}
                                                    </span>
                                                </td>
                                                <td>{item.old_name}</td>
                                                <td style={{ color: '#666', textAlign: 'center' }}>{item.old_created_date}</td>
                                                <td>{item.new_name}</td>
                                                <td style={{ color: '#666', textAlign: 'center' }}>{item.new_created_date}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                {/* Optional Footer */}
                
  <Modal.Footer className="modal_footer_edit_status">
    <div className="btn__group">
      <button type="button" className="btn_cancel" onClick={() => { setIsDataTableModalOpen(false); }}>Cancel</button>
    </div>
  </Modal.Footer> 
 
            </Modal>

        </>
    );
}

export default RecentlyChangedSymbols;
